import { ReactElement } from 'react';

import Alert from '@mui/material/Alert';

import { OrgVanityUrlRequest } from '../../types/Page';
import GratiDirectory from '../common/GratiDirectory';
import Hourglass from '../common/Hourglass';

import OrgVanityUrlRequestListItem from './OrgVanityUrlRequestListItem';

interface OrgVanityUrlRequestDirectoryProps {
  requests?: OrgVanityUrlRequest[];
  isLoading?: boolean;
  error?: Error | null;
  pageTitle?: string;
}

export default function OrgVanityUrlRequestDirectory({
  requests,
  isLoading,
  error,
  pageTitle,
}: OrgVanityUrlRequestDirectoryProps): ReactElement {
  if (isLoading) {
    return <Hourglass />;
  }

  if (error) {
    return <Alert severity="error">Error loading vanity URL requests: {error.message}</Alert>;
  }

  if (!requests || requests.length === 0) {
    return <Alert severity="info">{pageTitle ? `${pageTitle}: ` : ''}No requests found.</Alert>;
  }

  return (
    <GratiDirectory>
      {requests.map((request) => (
        <OrgVanityUrlRequestListItem key={request.itemId} request={request} isDividerDisplayed={true} />
      ))}
    </GratiDirectory>
  );
}
